import script from "./ScanQRCode.vue?vue&type=script&setup=true&lang=js"
export * from "./ScanQRCode.vue?vue&type=script&setup=true&lang=js"

import "./ScanQRCode.vue?vue&type=style&index=0&id=64baee40&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64baee40"]])

export default __exports__